import { useLocale } from '../i18n/LocaleContext';
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const CTA = () => {
  const { t, appLink } = useLocale();
  return (
    <CTASection>
      <div className="container">
        <CTACard
          as={motion.div}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <CTAContent>
            <CTATitle>{t('cta.title')}</CTATitle>
            <CTADescription>
              {t('cta.description')}
            </CTADescription>
            <CTAButtonContainer>
              <PrimaryButton
                href={appLink()}
                target="_blank" rel="noopener noreferrer"
                as={motion.a}
                whileHover={{ y: -5 }}
                whileTap={{ scale: 0.95 }}
              >
                {t('common.start')}
              </PrimaryButton>
              <SecondaryButton
                href="mailto:founders@noteician.com"
                as={motion.a}
                whileHover={{ y: -5 }}
                whileTap={{ scale: 0.95 }}
              >
                {t('common.work')}
              </SecondaryButton>
            </CTAButtonContainer>
          </CTAContent>
        </CTACard>
      </div>
    </CTASection>
  );
};

const CTASection = styled.section`
  padding: 100px 0;
  background-color: var(--light-gray);
`;

const CTACard = styled.div`
  border-radius: 20px;
  background: var(--gradient);
  padding: 60px;
  box-shadow: var(--shadow);
  text-align: center;

  @media (max-width: 768px) {
    padding: 40px 20px;
  }
`;

const CTAContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const CTATitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: white;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const CTADescription = styled.p`
  font-size: 1.25rem;
  line-height: 1.6;
  margin-bottom: 40px;
  color: rgba(255, 255, 255, 0.9);
`;

const CTAButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: center;
  }
`;

const PrimaryButton = styled.a`
  display: inline-block;
  padding: 15px 30px;
  background: white;
  color: var(--primary);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  box-shadow: var(--shadow);
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  @media (max-width: 576px) {
    width: 100%;
  }
`;

const SecondaryButton = styled.a`
  display: inline-block;
  padding: 15px 30px;
  background: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  @media (max-width: 576px) {
    width: 100%;
  }
`;

export default CTA;